export const UPDATE_APPROVALS_SEARCH = 'UPDATE_APPROVALS_SEARCH';

export interface SearchApprovalsPayload {
    query: string;
}

// Actions

export interface UpdateApprovalsSearchAction {
    type: typeof UPDATE_APPROVALS_SEARCH;
    payload: SearchApprovalsPayload;
}

// Action creators

export const updateApprovalsSearch: (payload: SearchApprovalsPayload) => UpdateApprovalsSearchAction = (payload) => {
    return {
        type: UPDATE_APPROVALS_SEARCH,
        payload,
    };
};
